import React from 'react'
import Lottie from "lottie-react";
import loadingAnimation from "./email.json";


export default function Popup(props) {
    const clickOutBehavior = (props.type === "error") ? { show: false, type: "" } : { show: true, type: "loading" }
    const title = (props.type === "error") ? "There was an issue with processing your results" : "Processing your results";
    const subtitle = (props.type === "error") ? "Click anywhere to dismiss. Try again by clicking submit." : "Do not exit to avoid any data loss.";
    return (
        <div className="Popup" onClick={() => props.handleTogglePopup(clickOutBehavior)}>
            <div className="Popup--container">
                <div className="Popup--image-container">
                    {props.type === "error" && <img className="Popup--image" src="/error.png" alt="Error" />}
                    {props.type == "loading" && <Lottie
                        animationData={loadingAnimation}
                        loop={true}
                    />}
                </div>
                <h1 className="Popup--title">{title}</h1>
                <h1 className="Popup--subtitle">{subtitle}</h1>
            </div>
        </div>
    )
}